module.exports = __webpack_public_path__ + "img/homeVote.6aec5dd1.png";